import { forwardRef, useCallback, useState } from 'react';
import { DebounceInput } from 'react-debounce-input';

class CustomDebounceInput extends DebounceInput {
  onChange = (event) => {
    event.persist();

    const { value: oldValue } = this.state;
    const { minLength } = this.props;

    this.setState({ value: event.target.value }, () => {
      const { value } = this.state;

      if (`${value}`.length >= minLength) {
        this.notify(event);
        return;
      }

      // If user hits backspace and goes below minLength consider it cleaning the value
      if (`${oldValue}`.length > `${value}`.length) {
        this.notify({ ...event, target: { ...event.target, value: '' } });
      }
    });
  };
}

const INITIAL_FORCE_RELOAD_INDEX = 0;

export const withInputDebounce = () => (BaseComponent) =>
  forwardRef(
    (
      {
        debounceTimeout = 300,
        debounceInputRef,
        inputRef,
        onBlur,
        autoFocus: autoFocusProp,
        ...props
      },
      ref
    ) => {
      const BaseComponentWithInputRef = useCallback(
        forwardRef(({ ...props }, ref) => {
          return <BaseComponent {...props} inputRef={inputRef} ref={ref} />;
        }),
        [inputRef]
      );

      const [forceReloadIndex, setForceReloadIndexId] = useState(
        () => INITIAL_FORCE_RELOAD_INDEX
      );

      const handleBlur = useCallback((e) => {
        setForceReloadIndexId((index) => index + 1);
        if (onBlur) {
          onBlur(e);
        }
      }, []);

      return (
        <CustomDebounceInput
          ref={debounceInputRef}
          key={forceReloadIndex}
          inputRef={ref}
          element={BaseComponentWithInputRef}
          debounceTimeout={debounceTimeout}
          onBlur={handleBlur}
          {...props}
          autoFocus={
            autoFocusProp && forceReloadIndex === INITIAL_FORCE_RELOAD_INDEX
          }
        />
      );
    }
  );

export default withInputDebounce;
